module.exports = __webpack_public_path__ + "static/media/my-projects-icon.5c67fee3.svg";